export default __webpack_public_path__ + "static/media/sun-source-logo.ea98196e.png";